/* eslint-disable max-len */
import { TRANSLATION_FILES } from '../constants/translation';
import valueToText from '../utils/valueToText';

export function translateModels(t, key, modelName, defaultValue) {
  const option = {
    ns: TRANSLATION_FILES.models[modelName],
  };
  if (defaultValue) {
    option.defaultValue = defaultValue;
  }
  return t(key, option);
}

export const getConstantsLabel = (t, options, value) => {
  if (Array.isArray(value)) {
    const newValue = [];
    value.forEach(v => newValue.push(t(valueToText(options, v), { ns: TRANSLATION_FILES.constants })));
    return newValue.join(', ');
  }
  if (value) {
    return t(valueToText(options, value), { ns: TRANSLATION_FILES.constants });
  }
  return value;
};



// WEBPACK FOOTER //
// ./src/utils/translation.js